import { Controller } from "@hotwired/stimulus"

// A row wider than the screen (the filter bar on a phone, 15 Oct 2026): the
// edge it goes on past fades (data-fade="left right", styled in
// application.tailwind.css), so the tiles out of sight read as there; and the
// chosen tile (data-pick) is brought into view — a zone picked at the far end
// used to reload the page with its own tile off screen.
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.element.addEventListener("scroll", this.update, { passive: true })
    window.addEventListener("resize", this.update)
    const pick = this.element.querySelector("[data-pick]")
    if (pick) {
      // Measured with rects rather than offsetLeft, and set on scrollLeft rather
      // than scrollIntoView, which would scroll the page too (partners_view).
      const offset = pick.getBoundingClientRect().left - this.element.getBoundingClientRect().left
      this.element.scrollLeft += offset - (this.element.clientWidth - pick.offsetWidth) / 2
    }
    this.update()
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.update)
    window.removeEventListener("resize", this.update)
  }

  update() {
    const e = this.element
    const fade = []
    if (e.scrollLeft > 1) fade.push("left")
    if (e.scrollLeft + e.clientWidth < e.scrollWidth - 1) fade.push("right")
    e.dataset.fade = fade.join(" ")
  }
}
